export default __webpack_public_path__ + "static/media/no-gtp.66d33b90.png";